import { render, staticRenderFns } from "./IssueDetails.vue?vue&type=template&id=3df2fe92"
import script from "./IssueDetails.vue?vue&type=script&lang=js"
export * from "./IssueDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports